/**
 * THIS FILE IS AUTOGENERATED, DO NOT EDIT IT!
 *
 * See codegen config in .graphqlrc.yml for details
 */

/** Internal type. DO NOT USE DIRECTLY. */
type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
/** Internal type. DO NOT USE DIRECTLY. */
export type Incremental<T> =
  | T
  | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
import { gql } from 'urql';
import * as Urql from 'urql';

import type * as Types from '@sg/graphql-schema';
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
/** Identity provider that verifies community membership. */
export type CommunityVerificationProvider = 'IDME';

/** Whether a verified group membership is still within its verification window. */
export type VerifiedGroupStatus = 'ACTIVE' | 'EXPIRED';

export type VerifiedGroupsQueryVariables = Exact<{ [key: string]: never }>;

export type VerifiedGroupsQuery = {
  readonly verifiedGroups: ReadonlyArray<{
    readonly provider: Types.CommunityVerificationProvider;
    readonly group: string;
    readonly status: Types.VerifiedGroupStatus;
    readonly verifiedAt: string;
    readonly expiresAt: string;
  }>;
};

export const VerifiedGroupsDocument = gql`
  query VerifiedGroups {
    verifiedGroups {
      provider
      group
      status
      verifiedAt
      expiresAt
    }
  }
`;

export function useVerifiedGroupsQuery(
  options?: Omit<Urql.UseQueryArgs<VerifiedGroupsQueryVariables>, 'query'>,
) {
  return Urql.useQuery<VerifiedGroupsQuery, VerifiedGroupsQueryVariables>({
    query: VerifiedGroupsDocument,
    ...options,
  });
}
